import { actions, selectors } from 'data'
import { connect, ConnectedProps } from 'react-redux'
import { isCompact } from 'utils'
import { withNavigate } from 'utils/withNavigate'

import WhatsNew from './template'

export type PropsType = ConnectedProps<typeof connector>

const mapStateToProps = (state, ownProps) => {
  const currency = ownProps.currency ?? selectors.app.getModalOptions(state).currency
  return {
    currency,
    smallScreen: isCompact(selectors.app.getScreenWidth(state)),
    symbol: selectors.instrument.getSymbol(state),
    tickerData: selectors.ticker.getAll(state)[`${currency}-USD`]
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  hideModal: () => {
    if (ownProps.onClose) ownProps.onClose()
    dispatch(actions.app.hideModal('WHATS_NEW'))
  },
  onClick: (currency, props) => {
    dispatch(props.navigate.push(`/trade/${currency}-USD`))
    if (ownProps.onClose) ownProps.onClose()
    dispatch(actions.app.hideModal('WHATS_NEW'))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(withNavigate(WhatsNew))
